const topics = [
  { title: '娱乐圈八卦', desc: '明星恋情、婚变、纠纷全收录', icon: 'ri-heart-pulse-line', color: 'text-primary-500', bg: 'bg-primary-50' },
  { title: '社会热点', desc: '全网热议话题深度扒皮', icon: 'ri-fire-line', color: 'text-accent-500', bg: 'bg-accent-50' },
  { title: '网红翻车', desc: '直播带货翻车实录', icon: 'ri-alert-line', color: 'text-primary-500', bg: 'bg-primary-50' },
  { title: '影视吐槽', desc: '烂片烂剧吐槽合集', icon: 'ri-movie-2-line', color: 'text-accent-500', bg: 'bg-accent-50' },
  { title: '综艺名场面', desc: '高能片段逐帧分析', icon: 'ri-tv-line', color: 'text-secondary-500', bg: 'bg-secondary-50' },
  { title: '电竞圈吃瓜', desc: '战队转会、选手八卦', icon: 'ri-gamepad-line', color: 'text-primary-500', bg: 'bg-primary-50' },
  { title: '时尚翻车', desc: '明星穿搭翻车大赏', icon: 'ri-t-shirt-line', color: 'text-accent-500', bg: 'bg-accent-50' },
  { title: '音乐圈瓜田', desc: '新歌争议、版权大战', icon: 'ri-music-2-line', color: 'text-secondary-500', bg: 'bg-secondary-50' },
  { title: '每日吃瓜精选', desc: '编辑精选必看合集', icon: 'ri-star-line', color: 'text-primary-500', bg: 'bg-primary-50' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
          <i className="ri-compass-3-line text-accent-500 mr-2 w-6 h-6 inline-flex items-center justify-center align-middle"></i>
          吃瓜专题索引
        </h2>
        <p className="text-sm text-foreground-500 mb-8">全网最新吃瓜资源一网打尽，按专题分类快速浏览</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="flex items-start gap-3 p-4 bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-200 transition-colors duration-200 group cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-lg ${item.bg} flex items-center justify-center flex-shrink-0`}>
                <i className={`${item.icon} ${item.color} text-lg w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-bold text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">{item.title}</h3>
                <p className="text-xs text-foreground-400 mt-0.5">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}